import * as Edit from './ImageDataEdit.js';
import Selection from "./Selection";

export default class SelectionProcessor {
	constructor() {
    this._width = 0;
    this._height = 0;
    this._lassoMask = null;
    this._selectionImage = null;
    this._selectionRect = null;
    this._orgRect = null;
    this._selectionObj = null;
    this._selectionRad = 0;
    this._selectionFlipedX = false;
    this._selectionFlipedY = false;
    this._selectionPivotX = 0;
    this._selectionPivotY = 0;
    this._algoName = 'Auto';
	}
  initWithImageSplitting(tgtImage, tgtX, tgtY, tgtW, tgtH, lassoMask, algoName) {
    this._initWithImageSplitting(tgtImage, tgtX, tgtY, tgtW, tgtH, lassoMask, true);
		this.prepareSelectionTransformAlgo(algoName);
  }
  _initWithImageSplitting(tgtImage, tgtX, tgtY, tgtW, tgtH, lassoMask, splitImage) {
    this._width = tgtImage.width;
    this._height = tgtImage.height;
    this._lassoMask = lassoMask;
		this._selectionRect = [tgtX, tgtY, tgtW, tgtH];
    this._orgRect = this._selectionRect.slice();
    [this._selectionPivotX, this._selectionPivotY] = Selection.rectCenter(this._selectionRect);

    if(splitImage) {
      this._selectionImage = new ImageData(tgtW, tgtH);
      Edit.pasteImage(this._selectionImage, tgtImage, -tgtX, -tgtY, (dstPixel, srcPixel, dstI, srcI) => {
        if(!lassoMask || lassoMask[srcI]) {
          dstPixel.set(srcPixel);
          srcPixel.set(Edit.ZERO_PIXEL);
        }
      });
    }
  }
  async initWithBlob(blob, lastCopiedRect, algoName, width, height) {
    this._width = width;
    this._height = height;
    this._lassoMask = null;
    const img = document.createElement('img');
    await new Promise(ok => {
      img.onload = () => ok();
      img.src = URL.createObjectURL(blob);
    });
    const ctx = new OffscreenCanvas(img.width, img.height).getContext('2d');
    ctx.drawImage(img, 0, 0);
    URL.revokeObjectURL(img.src);
    this._selectionImage = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
    if(
      lastCopiedRect &&
      this._selectionImage.width === lastCopiedRect[2] &&
      this._selectionImage.height === lastCopiedRect[3]
    ) {
      this._selectionRect = lastCopiedRect.slice();
    } else {
      const x = Math.floor((this._width - this._selectionImage.width) / 2);
      const y = Math.floor((this._height - this._selectionImage.height) / 2);
      this._selectionRect = [x, y, ctx.canvas.width, ctx.canvas.height];
      lastCopiedRect = null;
    }
    this._orgRect = this._selectionRect.slice();
    [this._selectionPivotX, this._selectionPivotY] = Selection.rectCenter(this._selectionRect);
    this.prepareSelectionTransformAlgo(algoName);
    return this._selectionRect.slice();
  }
  initWithAnother(tgtImage, another, useAnotherImage = false, clear = false) {
    if(useAnotherImage && another._selectionImage) {
      this._initWithImageSplitting(tgtImage, ...another._orgRect, another._lassoMask, false);
      this._selectionImage = another._selectionImage;
    } else {
      this._initWithImageSplitting(tgtImage, ...another._orgRect, another._lassoMask, true);
    }

    if(clear) {
      this._selectionImage.data.fill(0);
    }

    this._selectionRect = another._selectionRect.slice();
    this._selectionPivotX = another._selectionPivotX;
    this._selectionPivotY = another._selectionPivotY;
    this._selectionRad = another._selectionRad;
    this._selectionFlipedX = another._selectionFlipedX;
    this._selectionFlipedY = another._selectionFlipedY;
		
    if(useAnotherImage && another._selectionImage) {
      this._algoName = another._algoName;
      this._selectionObj = another._selectionObj;
    } else {
      this.prepareSelectionTransformAlgo(another._algoName);
    }
  }
	/*---------------- 選択範囲操作 ----------------*/
	moveSelection(x, y) {
		this._selectionRect[0] = x;
		this._selectionRect[1] = y;
		[this._selectionPivotX, this._selectionPivotY] = Selection.rectCenter(this._selectionRect);
	}
	resizeSelection(x, y, w, h) {
		this._selectionRect = [x, y, w, h];
	}
	rotateSelection(rad) {
		this._selectionRad = rad;
	}
	flipSelectionX() {
		this._selectionFlipedX = !this._selectionFlipedX;
	}
	flipSelectionY() {
		this._selectionFlipedY = !this._selectionFlipedY;
	}
  /*---------------- 選択範囲整形 ----------------*/
  prepareSelectionTransformAlgo(algoName) {
    this._algoName = algoName;
    this._selectionObj = null;
    switch(algoName) {
    case 'RotSprite':
      this._prepareRotSprite();
      break;
    case 'FastRotSprite':
      this._prepareRotSprite(3);
      break;
    case 'Auto':
      if(this._selectionImage.width * this._selectionImage.height <= 128 * 128) {
        this._prepareRotSprite();
      }
      break;
    }
  }
  getSelectionImage(keepWithinCanvas = false) {
    switch(this._algoName) {
    case 'RotSprite':
    case 'FastRotSprite':
      return this._getSelectionImageWithRotSprite(keepWithinCanvas);
    case 'BrowserAPI':
      return this._getSelectionImageWithBrowserAPI(keepWithinCanvas, false);
    case 'BrowserAPISmooth':
      return this._getSelectionImageWithBrowserAPI(keepWithinCanvas, true);
    case 'Auto':
      if(this._selectionImage.width * this._selectionImage.height <= 128 * 128) {
        return this._getSelectionImageWithRotSprite(keepWithinCanvas);
      } else {
        return this._getSelectionImageWithBrowserAPI(keepWithinCanvas, false);
      }
    }
  }
  getBlankImage() {
    const image = new ImageData(this._selectionImage.width, this._selectionImage.height);
    const [ofsX, ofsY, width, height] = this._selectionRect;
    return {image, ofsX, ofsY, width, height};
  }
  _getSelectionRectRegardingRad(keepWithinCanvas) {
    let retRect;
    if(this._selectionRad) {
      const pivot = [this._selectionPivotX, this._selectionPivotY];
      let [x1, y1, x2, y2] = [this._width - 1, this._height - 1, 0, 0];
      let fourCorners;
      {
        const [sx1, sy1, sw, sh] = this._selectionRect;
        const [sx2, sy2] = [sx1 + sw - 1, sy1 + sh - 1];
        fourCorners = [[sx1, sy1], [sx1, sy2], [sx2, sy1], [sx2, sy2]];
      }
      for(let i = 0; i < 4; ++i) {
        const [x, y] = fourCorners[i];
        const [rx, ry] = Selection.rotate2D([x + .5, y + .5], pivot, this._selectionRad).map(Math.floor);
        x1 = Math.min(x1, rx);
        y1 = Math.min(y1, ry);
        x2 = Math.max(rx, x2);
        y2 = Math.max(ry, y2);
      }
      console.assert(x1 <= x2 && y1 <= y2);
      retRect = [x1, y1, x2 - x1 + 1, y2 - y1 + 1];
    } else {
      retRect = this._selectionRect;
    }
    if(keepWithinCanvas) {
      return this._keepRectWithinCanvas(retRect);
    } else {
      return retRect;
    }
  }
  _keepRectWithinCanvas(rect) {
    let [x, y, w, h] = rect;
    x = Math.max(0, x);
    y = Math.max(0, y);
    w = Math.min(w, this._width - x);
    h = Math.min(h, this._height - y);
    return [x, y, w, h];
  }
  /*---------------- RotSprite ----------------*/
  _prepareRotSprite(scale = 8) {
    console.assert(this._selectionImage);
    let scaledImage = this._selectionImage;
    let s = scale;
    while(1 < s) {
      if(s % 3 === 0) {
        scaledImage = Edit.scale3x(scaledImage);
        s /= 3;
      } else if(s % 2 === 0) {
        scaledImage = Edit.scale2x(scaledImage);
        s /= 2;
      } else {
        throw new Error('invalid scale for RotSprite');
      }
    }
    this._selectionObj = {
      for: 'RotSprite',
      scaledImage,
      scale,
    };
  }
  _getSelectionPixelWithRotSprite(canvasRealX, canvasRealY) {
    const {width: selectionW, height: selectionH} = this._selectionImage;
    const [selectedX, selectedY, selectedW, selectedH] = this._selectionRect;
    const xInSelection = (canvasRealX - selectedX) * selectionW / selectedW;
    const yInSelection = (canvasRealY - selectedY) * selectionH / selectedH;
    if(!(0 <= xInSelection && xInSelection < selectionW && 0 <= yInSelection && yInSelection < selectionH)) {
      return null;
    }
    const {scaledImage, scale} = this._selectionObj;
    const flip = (value, size, flag) => {
      if(flag) {
        return size - 1 - value;
      } else {
        return value;
      }
    };
    const xInScaled = flip(Math.floor(xInSelection * scale), selectionW * scale, this._selectionFlipedX);
    const yInScaled = flip(Math.floor(yInSelection * scale), selectionH * scale, this._selectionFlipedY);
    const layerIdx = (yInScaled * selectionW * scale + xInScaled) * 4;
    return scaledImage.data.subarray(layerIdx, layerIdx + 4);
  }
  _getSelectionImageWithRotSprite(keepWithinCanvas) {
    const pivot = [this._selectionPivotX, this._selectionPivotY];
    const [ofsX, ofsY, width, height] = this._getSelectionRectRegardingRad(keepWithinCanvas);
    const image = new ImageData(width, height);
    for(let y = 0; y < height; ++y) {
      for(let x = 0; x < width; ++x) {
        let points = [ofsX + x + .5, ofsY + y + .5];
        if(this._selectionRad) points = Selection.rotate2D(points, pivot, -this._selectionRad);
        const pixel = this._getSelectionPixelWithRotSprite(...points);
        if(pixel) image.data.set(pixel, (y * width + x) * 4);
      }
    }
    return {image, ofsX, ofsY, width, height};
  }
  /*---------------- BrowserAPI ----------------*/
  _getSelectionImageWithBrowserAPI(keepWithinCanvas, smooth) {
    const {width: sw, height: sh} = this._selectionImage;
    const [dx, dy, dw, dh] = this._selectionRect;
    const ctx = new OffscreenCanvas(dw + 2, dh + 2).getContext('2d');
    {
      const ctx2 = new OffscreenCanvas(sw, sh).getContext('2d');
      ctx2.putImageData(this._selectionImage, 0, 0);
      const signX = this._selectionFlipedX ? -1 : 1;
      const signY = this._selectionFlipedY ? -1 : 1;
      ctx.scale(signX, signY);
      ctx.imageSmoothingEnabled = smooth;
      ctx.drawImage(ctx2.canvas, 0, 0, sw, sh, signX, signY, signX * dw, signY * dh);
    }
    const pivotX = this._selectionPivotX - dx;
    const pivotY = this._selectionPivotY - dy;
    const ctx2 = new OffscreenCanvas(this._width, this._height).getContext('2d');
    ctx2.translate(dx + pivotX, dy + pivotY);
    if(this._selectionRad) ctx2.rotate(this._selectionRad);
    ctx2.imageSmoothingEnabled = smooth;
    ctx2.drawImage(ctx.canvas, -pivotX - 1, -pivotY - 1);
    const [ofsX, ofsY, width, height] = this._getSelectionRectRegardingRad(keepWithinCanvas);
    const image = ctx2.getImageData(ofsX, ofsY, width, height);
    return {image, ofsX, ofsY, width, height};
  }
}
